import { client } from "helpers/client";
import { PreregisterDto, usePreregisterData } from "pages/registration/registration.service";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import React, { useMemo } from "react";
import { useStatus } from "hooks/use-status";
import { toast } from "react-toastify";

export const ResendLinks = {
  resetPassword: "auth/resendForgetPasswordEmailLink",
  verifyEmail: "auth/resendVerificationEmailLink",
  verifyAlternativeEmail: "security/verifyAlternativeEmail"
};

export type ResendActionType = keyof typeof ResendLinks;

interface LookUp {
  id: number;
  name: string;
  phoneCode?: string;
}

export class InfoService {
  static getCompanySizes() {
    return client<LookUp[]>("contactUs/companySize/getAll").then((res) => res.response ?? []);
  }

  static getCountries() {
    return client<LookUp[]>("contactUs/country/getAll").then((res) => res.response ?? []);
  }

  static getIndustryFields() {
    return client<LookUp[]>("contactUs/industry/getAll").then((res) => res.response ?? []);
  }

  static async resendLink(emailId: string, type: ResendActionType = "verifyEmail", data: any) {
    const link = ResendLinks[type];
    if (type === "verifyAlternativeEmail") return await client<PreregisterDto>(`/${link}`, { data });
    return await client<PreregisterDto>(`/${link}/${emailId}`, {
      method: "POST"
    });
  }
}

export function useVerifyEmailToken(url = "/register", options = {}) {
  const { token } = useParams();
  const { load, isLoading, done, stop } = useStatus("loading");
  const { preregisterData, setPreregisterData } = usePreregisterData();
  console.log("asdasdasdasd");
  const verify = React.useCallback(async () => {
    load();
    if (!token) return;
    try {
      const { response } = await client<PreregisterDto>("auth/verifyEmail", {
        data: { token },
        ...options
      });
      if (response) {
        setPreregisterData(response);
        done();
        return;
      }
    } catch (error) {
      console.log(error);
      return;
    }
  }, [token]);

  const memo = useMemo(() => {
    verify();
  }, [verify]);

  return { preregisterData, isLoading };
}

export function useResendEmailToken() {
  const navigate = useNavigate();
  const location = useLocation();
  const routeState = (location.state as { actionType: ResendActionType; data: any }) || {};

  const { isLoading, load, done, stop } = useStatus();

  const methods = usePreregisterData();
  const { preregisterData, isStillBlocked, setPreregisterData } = methods;

  async function handleResendEmailCode() {
    load();
    if (isStillBlocked) {
      stop();
      return navigate("/info/blocked-email", { state: routeState });
    }
    try {
      const { response, error } = await InfoService.resendLink(
        preregisterData!.emailId.toString(),
        routeState.actionType,
        routeState.data
      );
      if (response) {
        setPreregisterData(response);
        done();
      }
      if (error) return stop();
    } catch (e: any) {
      toast.error(e.toString());
      stop();
    }
  }

  return { isLoading, handleResendEmailCode, routeState, ...methods };
}
